import AngleLeftIcon from "./AngleLeftIcon";
import AngleRightIcon from "./AngleRightIcon";
import CalendarIcon from "./CalendarIcon";
import CaretDownIcon from "./CaretDownIcon";
import ClockIcon from "./ClockIcon";
import CogIcon from "./CogIcon";
import CubesIcon from "./CubesIcon";
import DangerIcon from "./DangerIcon";
import ExcelIcon from "./ExcelIcon";
import EyeIcon from "./EyeIcon";
import PdfIcon from "./PdfIcon";
import PuzzlePieceIcon from "./PuzzlePieceIcon";
import SadTearIcon from "./SadTearIcon";
import SignInIcon from "./SignInIcon";
import SignOutIcon from "./SignOutIcon";
import SortDownIcon from "./SortDownIcon";
import SortUpIcon from "./SortUpIcon";
import StarIcon from "./StarIcon";
import SyncIcon from "./SyncIcon";
import TachometerIcon from "./TachometerIcon";
import TagsIcon from "./TagsIcon";
import UserIcon from "./UserIcon";
import UsersIcon from "./UsersIcon";
import UserRobotIcon from "./UserRobotIcon";
import UserUnlockIcon from "./UserUnlockIcon";
import GoogleIcon from "./GoogleIcon";
import AppleMapsIcon from "./AppleMapsIcon";
import BingIcon from "./BingIcon";
import YelpIcon from "./YelpIcon";
import BellIcon from "./BellIcon";
import PublishingIcon from "./PublishingIcon";
import PublishedIcon from "./PublishedIcon";
import BusinessPhoneIcon from "./BusinessPhoneIcon";
import BusinessHoursIcon from "./BusinessHoursIcon";
import ForwardBusinessPhoneIcon from "./ForwardBusinessPhoneIcon";
import InfoIcon from "./InfoIcon";
import MailIcon from "./MailIcon";
import WorldwideIcon from "./WorldwideIcon";
import PhoneCircleIcon from "./PhoneCircleIcon";
import BanBlueIcon from "./BanBlueIcon";
import AsterixCircleIcon from "./AsterixCircleIcon";
import MailCircleIcon from "./MailCircleIcon";
import MediaStopIcon from "./MediaStopIcon";
import MediaPlayIcon from "./MediaPlayIcon";
import MediaPauseIcon from "./MediaPauseIcon";
import MediaVolumeDownIcon from "./MediaVolumeDownIcon";
import MediaVolumeUpIcon from "./MediaVolumeUpIcon";
import DownloadIcon from "./DownloadIcon";
import BarChartIcon from "./BarChartIcon";
import BullseyeIcon from "./BullseyeIcon";
import MoneyIcon from "./MoneyIcon";
import SignalIcon from "./SignalIcon";
import ThumbsUpIcon from "./ThumbsUpIcon";
import CheckIcon from "./CheckIcon";
import EditIcon from "./EditIcon";
import NotesIcon from "./NotesIcon";

let icons = [
    AngleLeftIcon,
    AngleRightIcon,
    CalendarIcon,
    CaretDownIcon,
    ClockIcon,
    CogIcon,
    CubesIcon,
    DangerIcon,
    ExcelIcon,
    EyeIcon,
    PdfIcon,
    PuzzlePieceIcon,
    SadTearIcon,
    SignInIcon,
    SignOutIcon,
    SortDownIcon,
    SortUpIcon,
    StarIcon,
    SyncIcon,
    TachometerIcon,
    TagsIcon,
    UserIcon,
    UserRobotIcon,
    UsersIcon,
    UserUnlockIcon,
    GoogleIcon,
    AppleMapsIcon,
    BingIcon,
    YelpIcon,
    BellIcon,
    PublishingIcon,
    PublishedIcon,
    BusinessHoursIcon,
    BusinessPhoneIcon,
    ForwardBusinessPhoneIcon,
    InfoIcon,
    MailIcon,
    WorldwideIcon,
    PhoneCircleIcon,
    BanBlueIcon,
    AsterixCircleIcon,
    MailCircleIcon,
    MediaStopIcon,
    MediaPlayIcon,
    MediaPauseIcon,
    MediaVolumeDownIcon,
    MediaVolumeUpIcon,
    DownloadIcon,
    BarChartIcon,
    BullseyeIcon,
    MoneyIcon,
    SignalIcon,
    ThumbsUpIcon,
    CheckIcon,
    EditIcon,
    NotesIcon
];

export default {
    install(Vue) {
        icons.forEach((item) => {
            Vue.component(item.name, item);
        });
    }
}